import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTabQuery } from 'hooks/useQueryState'
import { usePermissions } from 'hooks/useProCptPermission'
import CreateDialog from '../PaintingRequests/CreateDialog'
import SyncFromBitableDialog from '../PaintingRequests/SyncFromBitableDialog'
import BatchOnlineFrameTagsTab from './BatchOnlineFrameTagsTab'
import TagPromptLabTab from './TagPromptLabTab'
import PaintingRequestsTab from './PaintingRequestsTab'
import TempSpineZips from '../TempSpineZips'
import BotPk from '../BotPk'
import LibraryTabConfTab from './LibraryTabConf/LibraryTabConfTab'
import PushMaterialPrepTab from './PushMaterialPrepTab'

function NoLibraryTabConfPermissionNotice() {
  return (
    <div className="rounded-md border border-dashed bg-muted/40 px-6 py-12 text-center text-sm text-muted-foreground">
      缺少权限：你没有「客户端模版列表 RC」权限，无法查看或发布配置。请联系管理员开通。
    </div>
  )
}

export default function OpsTools() {
  const [tab, setTab] = useTabQuery('opsToolsTab', 'batch-online-frame-tags')
  const navigate = useNavigate()
  const { can } = usePermissions()
  const canManageLibraryTabConfRc = can('libraryTabConfRc')

  useEffect(() => {
    if (tab === 'search') {
      navigate('/admin/search', { replace: true })
    }
  }, [navigate, tab])

  return (
    <div className="flex h-[calc(100vh-98px)] min-h-0 flex-col">
      <Tabs
        value={tab}
        onValueChange={setTab}
        className="flex min-h-0 flex-1 flex-col space-y-4"
      >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-8">
          <h2 className="text-3xl font-bold tracking-tight">运营工具</h2>
          <TabsList>
            <TabsTrigger value="batch-online-frame-tags">
              修改线上模板标签
            </TabsTrigger>
            <TabsTrigger value="template-tag-recommend">
              模板标签推荐(ai)
            </TabsTrigger>
            <TabsTrigger value="painting-requests">绘画需求发起</TabsTrigger>
            <TabsTrigger value="temp-spine-zips">Temp spine zips</TabsTrigger>
            <TabsTrigger value="bot-pk">人机PK</TabsTrigger>
            <TabsTrigger value="library-tab-conf">Library tab conf</TabsTrigger>
            <TabsTrigger value="push-material-prep">push 素材准备</TabsTrigger>
          </TabsList>
        </div>
        {tab === 'painting-requests' ? (
          <div className="flex items-center gap-2">
            <SyncFromBitableDialog />
            <CreateDialog />
          </div>
        ) : null}
      </div>
      <TabsContent value="batch-online-frame-tags" className="space-y-4">
        <BatchOnlineFrameTagsTab />
      </TabsContent>
      <TabsContent value="template-tag-recommend" className="flex min-h-0 flex-1 flex-col overflow-hidden data-[state=inactive]:hidden">
        <TagPromptLabTab />
      </TabsContent>
      <TabsContent value="painting-requests" className="space-y-4">
        <PaintingRequestsTab />
      </TabsContent>
      <TabsContent value="temp-spine-zips" className="space-y-4">
        <TempSpineZips />
      </TabsContent>
      <TabsContent value="bot-pk" className="space-y-4">
        <BotPk />
      </TabsContent>
      <TabsContent value="library-tab-conf" className="space-y-4">
        {canManageLibraryTabConfRc ? (
          <LibraryTabConfTab />
        ) : (
          <NoLibraryTabConfPermissionNotice />
        )}
      </TabsContent>
      <TabsContent
        value="push-material-prep"
        className="mt-2 flex min-h-0 flex-1 flex-col overflow-hidden data-[state=inactive]:hidden"
      >
        <PushMaterialPrepTab />
      </TabsContent>
      </Tabs>
    </div>
  )
}
